import { render, staticRenderFns } from "./card-list-summary.vue?vue&type=template&id=385ffce0&scoped=true"
import script from "./card-list-summary.vue?vue&type=script&lang=js"
export * from "./card-list-summary.vue?vue&type=script&lang=js"
import style0 from "./card-list-summary.vue?vue&type=style&index=0&id=385ffce0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385ffce0",
  null
  
)

export default component.exports